import { createStore } from 'vuex';

const store = createStore({

  // 定义数据
  state: {
    userInfo: {
      username: '李思琦',
      passowrd: 'lisiqi',
      words: 'hello'
    },

    agreementItem: 'item1',
  },

  //同步方法
  mutations: {

    updateUserInfo(state, payload) {
      state.userInfo = payload;
    },

    updateAgreItem(state, payload) {
      state.agreementItem = payload;
    },

  },

  //异步方法
  actions: {

    updateUserInfoAsync(context, payload) {
      context.commit('updateUserInfo', payload);
    },

    updateAgreItemAsync(context, payload) {
      context.commit('updateAgreItem', payload);
    },

  },

});

export default store;